/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Smart Sash Admin API
 * RESTful API for Smart Sash device management, user authentication, and system administration
 * OpenAPI spec version: 0.13.0.0
 */

export type HoodType = typeof HoodType[keyof typeof HoodType];


export const HoodType = {
  CAV: 'CAV',
  VAV: 'VAV',
} as const;
